module.exports = __webpack_public_path__ + "school/img/campus_health_category_title_bg.d0dd9c71.png";